import { PureComponent } from 'react'
import { Field as FinalFormField } from 'react-final-form'
import { isDeepEqual } from '@/server-data'

import CustomFieldsListField from './CustomFieldsListField'
import { PublicProps as Props, FieldRenderProps } from './typings'

export default class CustomFieldsListFieldWrapper extends PureComponent<Props> {
  render() {
    const { name, ...props } = this.props

    return (
      <FinalFormField
        {...props}
        name={name}
        isEqual={isDeepEqual}
        render={(formProps: FieldRenderProps) => {
          return <CustomFieldsListField {...this.props} formProps={formProps} />
        }}
      />
    )
  }
}
